/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { StorageGasTest__factory } from "./StorageGasTest__factory";
